module.exports = __webpack_public_path__ + "img/btn-banner-buy-coins.088e453f.svg";